import { FeatureValueSymbol, SymbolModel, ValueSymbol } from '../model/SymbolModel'

/**
 * Check if a symbol is a ValueSymbol
 * @param symbol The symbol model to check
 * @returns Boolean
 */
export function isValueSymbol(symbol: SymbolModel): symbol is ValueSymbol {
    return 'timesStake' in symbol && 'start' in symbol.timesStake && 'end' in symbol.timesStake
}

/**
 * Check if a symbol is a FeatureValueSymbol
 * @param symbol The symbol model to check
 * @returns Boolean
 */
export function isFeatureValueSymbol(symbol: SymbolModel): symbol is FeatureValueSymbol {
    return 'cash' in symbol && 'start' in symbol.cash && 'end' in symbol.cash
}
